require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-imagicasa-soligo.json") })
        }
      }, "path---journal-imagicasa-soligo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-imagicasa-soligo!./.cache/json/journal-imagicasa-soligo.json
// module id = 500
// module chunks = 231608221292675